<template>
  <div class="container">
    <BaseFrame
      :breadcrumb="[
        {
          name: 'pointApply',
          title: '积分申请'
        },
        {
          name: 'pointApplyCreate',
          title: '新建申请'
        }
      ]"
      :btns="[
        {
          name: 'cancel',
          text: '取消',
        },
        {
          name: 'submit',
          text: '提交申请',
          type: 'primary'
        }
      ]"
      @btn-click="onBtnClick"
    >
      <div slot="content">
        <lk-card title="申请内容" class="other-card">
          <div class="head-container">
            <div class="row">
              <div class="item">
                <div class="title">申请门店：</div>
                <storeListSelect
                  style="width: 170px"
                  v-if="roleType === 1"
                  v-model="selectedStoreId"
                  class="item"
                  :multiple="true"
                  @on-change="handleChangeStore"
                ></storeListSelect>
                <div v-else>{{ storePoint.storeName }}</div>
              </div>
              <div class="item">
                <div class="title"><span class="require">* </span>申请年份：</div>
                <lk-date-picker
                  :clearable="false"
                  type="year"
                  :value="selectedYear"
                  :options="options"
                  @on-change="handleDateChange"
                >
                </lk-date-picker>
              </div>
            </div>
            <div class="row row-gap">
              <div class="item">
                <div class="title">本次申请积分：</div>
                <div>{{ applyUsedPoints }}</div>
              </div>
              <div class="item">
                <div class="title">可申请积分：</div>
                <div>{{ storePoint.totalNum }}</div>
              </div>
            </div>
          </div>
          <div class="warning"><span class="iconfont icon">{{'&#xe613;'}}</span>请勾选兑换积分患者信息，系统将自动计算本次申请积分</div>
          <div class="apply-container">
            <div class="row">
              <div class="title"><span class="require">* </span>申请明细：</div>
              <div>
                <lk-table
                  class="content"
                  border
                  :columns="columns"
                  :data="tableData"
                  @on-selection-change="handleSelectChange"
                />
                <lk-page
                    class="page-style"
                    :total="count"
                    :current.sync="page"
                    :page-size="size"
                    show-sizer
                    show-elevator
                    show-total
                    @on-page-size-change='handlePageSize'
                    @on-change='handlePage'
                    :page-size-opts='[10, 20,30,50,100]'
                  />
              </div>
            </div>
            <div class="row row-gap">
              <div class="title">申请备注：</div>
              <lk-input type='textarea' :maxlength='200' v-model="applyRemark" placeholder="请输入"></lk-input>
            </div>
          </div>
        </lk-card>
      </div>
    </BaseFrame>
  </div>
</template>

<script>

import _ from 'lodash';
import BaseFrame from '@/components/frame/NewBaseFrame.vue';
import utils from '../../../libs/utils';
import pointService from '../../../services/points';

export default {
  name: 'pointsApplyCreate',
  components: {
    BaseFrame,
  },
  data() {
    return {
      selectionData: { },
      loading: false,
      size: 10,
      count: 0,
      page: 1,
      selectedYear: new Date(),
      options: {
        disabledDate: utils.forbiddenDate.disabledFromToday,
      },
      applyRemark: '',
      storePoint: {
        storeId: 0, // 35, // 门店id
        storeName: '', // "州邻客大药房", ---门店名称
        yearVal: 0, // 2022,  ----年度
        totalAllNum: 0, // 300, ----总积分
        totalUsedNum: 0, // 100,  ---总已使用积分
        totalFrozenNum: 0, // 50,  ----总冻结积分
        totalNum: 0, // 150     ----总可用积分
      },
      columns: [
        {
          type: 'selection',
          width: 60,
          align: 'center',
          fixed: 'left',
        },
        { title: '患者信息', key: 'patientInfo', minWidth: 160 },
        { title: '可用积分', key: 'num', minWidth: 116 },
        {
          title: '本次申请',
          minWidth: 60,
          render: (h, { row, index }) => h('lk-input', {
            on: {
              'on-blur': (e) => {
                let v = parseInt(e.target.value) || 0;
                if (v > row.num) {
                  v = row.num;
                }
                if (v <= 0) {
                  v = 0;
                }

                if (this.tableData[index].applyNum != v) {
                  this.tableData[index]._checked = true;
                  this.$set(this.selectionData, this.page, this.tableData.filter(item => item._checked));
                }

                // 此处设置两次，是为了解决输入字符串问题，例如： 198 198sxsxsx parseInt 值相等导致页面不刷新
                this.tableData[index].applyNum = e;
                this.tableData[index].applyNum = v;
              },
            },
            props: {
              value: row.applyNum,
              placeholder: '请输入',
            },
          }),
        },
      ],
      tableData: [],
      applyUsedPoints: 0,
      selectedStoreId: null, // 选择的门店id
    };
  },
  watch: {
    selectionData: {
      handler(val) {
        let total = 0;
        for (const k in val) {
          const listSum = val[k].reduce((sum, item) => sum + parseInt(item.applyNum), 0);
          total += listSum;
        }
        this.applyUsedPoints = total;
      },
      deep: true,
    },
  },
  computed: {
    roleType() {
      return this.$store.state.user.roleType;
    },
  },
  methods: {
    getData() {
      const params = {
        yearVal: this.selectedYear.getFullYear(),
        storeId: this.roleType === 1 ? this.selectedStoreId : this.$store.state.storeInfo.id,
        page: this.page,
        size: this.size,
      };
      pointService.accountDetail(params).then((res) => {
        if (res.data.status === 200) {
          const tmp = [];
          this.count = res.data.data.count;
          res.data.data.list.forEach((item) => {
            // 赋值申请积分，可能会更改
            item.applyNum = item.num;
            const pat = /(\d{3})\d*(\d{4})/;
            item.patientInfo = `${item.patientName[0]}* ${item.patientPhone.replace(pat, '$1****$2')}`;
            if (this.selectionData[this.page]) {
              const r = this.selectionData[this.page].filter(obj => obj.id == item.id);
              if (r.length > 0) {
                item._checked = true;
                item.applyNum = r[0].applyNum;
              }
            }
            tmp.push(item);
          });
          this.tableData = tmp;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSelectChange(e) {
      const ids = e.map(item => item.id);
      this.tableData.forEach((item) => {
        item._checked = ids.includes(item.id);
      });
      this.$set(this.selectionData, this.page, this.tableData.filter(item => item._checked));
    },
    handlePageSize(val) {
      this.size = val;
      this.selectionData = { };
      this.getData();
    },
    handlePage(val) {
      this.page = val;
      this.getData();
    },
    handleDateChange(val) {
      this.$Modal.confirm({
        title: '提醒',
        content: '修改年份将重置填写内容，是否确认',
        onOk: () => {
          this.selectedYear = new Date(val);
          this.selectionData = { };
          this.getData();
          this.getStorePoints();
        },
        onCancel: () => {
          const t = this.selectedYear;
          this.selectedYear = new Date(val);
          this.selectedYear = new Date(t);
        },
      });
    },
    handleChangeStore(val) {
      if (!val) {
        this.storePoint = {
          storeId: 0, // 35, // 门店id
          storeName: '', // "州邻客大药房", ---门店名称
          yearVal: 0, // 2022,  ----年度
          totalAllNum: 0, // 300, ----总积分
          totalUsedNum: 0, // 100,  ---总已使用积分
          totalFrozenNum: 0, // 50,  ----总冻结积分
          totalNum: 0, // 150     ----总可用积分
        };
        this.selectionData = { };
        this.tableData = [];
        return;
      }
      this.getStorePoints();
      this.getData();
    },
    onBtnClick(val) {
      switch (val) {
        case 'submit': {
          let exchangeDetailList = [];
          for (const k in this.selectionData) {
            const l = this.selectionData[k].map((item) => {
              const obj = {};
              obj.patientId = item.patientId;
              obj.patientName = item.patientName;
              obj.patientPhone = item.patientPhone;
              obj.integalAccountId = item.id;
              obj.num = item.applyNum;
              return obj;
            });
            exchangeDetailList = exchangeDetailList.concat(l);
          }
          if (this.applyUsedPoints <= 0) {
            this.$Message.error('本次申请积分不能为0');
            return;
          }
          if (this.applyUsedPoints > this.storePoint.totalNum) {
            this.$Message.error('本次申请积分不能大于可申请积分');
            return;
          }
          const params = {
            storeId: this.storePoint.storeId,
            storeName: this.storePoint.storeName,
            integalNum: this.storePoint.totalNum,
            integalUsedNum: this.storePoint.totalUsedNum,
            exchangeNum: this.applyUsedPoints,
            yearVal: this.selectedYear.getFullYear(),
            remark: this.applyRemark.trim(),
            exchangeDetailList,
          };
          pointService.pointApplySubmit(params)
            .then((res) => {
              if (res.data.status !== 200) {
                this.$Message.error(res.data.error);
                return;
              }
              this.$Message.success('提交成功');
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
            })
            .catch((err) => {
              utils.handleError(err);
            });
        }
          break;
        case 'cancel':
          this.$router.go(-1);
          break;
        default:
          break;
      }
    },
    getStorePoints() {
      const params = {
        yearVal: this.selectedYear.getFullYear(),
        storeId: this.roleType === 1 ? this.selectedStoreId : this.$store.state.storeInfo.id,
      };
      pointService.storePoint(params)
        .then((res) => {
          if (res.data.status !== 200) {
            this.$Message.error(res.data.error);
            return;
          }
          this.storePoint = res.data.data;
        })
        .catch((err) => {
          utils.handleError(err);
        });
    },
  },
  created() {
    if (this.roleType !== 1) {
      this.getData();
      this.getStorePoints();
    }
  },
};
</script>
<style lang="less" scoped>

.other-card{
  margin-top: 30px;
}

.page-style {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.head-container {
  width: 900px;
  margin: 20px;
  .row {
    display: flex;
    justify-content: space-between;
    .item {
      .title {
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-right: 20px;
      }
      width: 300px;
      display: flex;
      align-items: center;
    }
  }

}
.row-gap {
  margin-top: 16px;
}

.warning {
  margin-left: 136px;
  display: flex;
  align-items: center;
  .icon {
    color: rgb(0, 167, 263);
  }
}

.apply-container {
  padding: 20px;
  .row {
    display: flex;
    flex: none;
    align-items: flex-start;
    .title {
      width: 100px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-right: 20px;
    }

    .content {
      width: 800px
    }
  }
}
.require {
  color: red;
  font-size: 20px;
  line-height: 20px;
  margin-top: 10px;
}

</style>
